import { graphql, useStaticQuery } from 'gatsby'
import { useCurrentLanguageKey } from '../context/i18n'
import { defaultLanguage } from '../../../config/storyblok/languages'

export const useTestimonials = (ids?: string[]) => {
  const query = graphql`
    query {
      allStoryblokEntry(filter: { field_component: { eq: "TestimonialSliderItem" } }) {
        nodes {
          field_component
          uuid
          content
          lang
        }
      }
    }
  `

  const res = useStaticQuery(query)
  const { nodes } = res.allStoryblokEntry
  const currentLanguage = useCurrentLanguageKey()

  const mappedNodes = nodes
    .filter(formData => {
      if (currentLanguage == defaultLanguage) {
        return formData.lang === 'default'
      }

      return formData.lang === currentLanguage
    })
    .filter(node => {
      if (!ids || ids.length === 0) {
        return true
      }

      return ids?.includes(node.uuid)
    })
    .map(node => {
      return {
        ...node,
        content: JSON.parse(node.content),
      }
    })
  return [...mappedNodes]
}
